import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['chatwindow', 'chatmessages', 'emptystate', 'messageslist']

  connect() {
    this.scrollOnNewMessage = this.scrollOnNewMessage.bind(this);
    document.addEventListener('turbo:before-stream-render', this.scrollOnNewMessage);
    this.syncJobPageLayoutState();
    this.scrollToBottom();
  }

  disconnect() {
    document.removeEventListener('turbo:before-stream-render', this.scrollOnNewMessage);
  }

  scrollOnNewMessage() {
    setTimeout(() => {
      this.scrollToBottom();
      this.syncJobPageLayoutState();
      if (this.statusDiv() != null) {
        this.statusDiv().innerHTML = "online"
        this.statusDiv().style.color = "#B9FF66";
      }
      const input = this.textArea();
      if (input) input.focus();
    }, "100");
  }

  open() {
    this.chatwindowTarget.style.display = "flex";
    this.syncJobPageLayoutState();
    this.scrollToBottom();
    const input = this.textArea();
    if (input) input.focus();
  }

  close(event) {
    if (event) event.preventDefault();
    console.log("Chat window closing...");
    this.chatwindowTarget.style.setProperty('display', 'none', 'important');
  }

  disableForm() {
    // Disable button to prevent double-submit
    this.submitButton().disabled = true;
    this.submitButton().classList.add("opacity-40");

    // Set input to read-only to prevent editing during processing
    // but DON'T disable it, otherwise the value won't be sent in the POST request
    const input = this.textArea();
    if (input) {
      input.readOnly = true;
      input.classList.add("opacity-60");
    }
  }

  enterPressed(event) {
    if (this.submitButton().disabled) {
      // console.log("btn disabled")
      return
    }

    if (event.keyCode == 13 && event.metaKey) {
      // console.log("enter pressed")
      this.chatForm().requestSubmit();
    }
  }

  // enterPressed(event) {
  //   this.textArea().value = this.textArea().value.trim()
  //   if (event.keyCode == 13 && !event.shiftKey && !event.metaKey) {
  //       if(this.textArea().value == "") {
  //         console.log("empty string")
  //         this.textArea().value = ""
  //         event.preventDefault();
  //       }
  //       this.chatForm().requestSubmit();
  //     }
  //   }

  // shiftEnterPressed(event) {
  //   if (event.keyCode == 13 && event.shiftKey) {
  //     console.log("shift + enter pressed")
  //     //this.textArea().value = this.textArea().value + " h1 "
  //   }
  // }

  submitButton() {
    return this.element.querySelector("#submit-button");
  }

  textArea() {
    return this.element.querySelector("#chat_message_user_question");
  }

  scrollToBottom() {
    this.chatmessagesTarget.scrollTop = this.chatmessagesTarget.scrollHeight;
  }

  syncJobPageLayoutState() {
    if (!this.hasChatwindowTarget || !this.hasEmptystateTarget || !this.hasMessageslistTarget) return;

    const hasMessages = this.messageslistTarget.querySelector('.chat-message-container') !== null;

    this.chatwindowTarget.classList.toggle('chat-has-messages', hasMessages);
    this.chatwindowTarget.classList.toggle('chat-is-empty', !hasMessages);

    this.emptystateTarget.classList.toggle('hidden', hasMessages);
    this.emptystateTarget.setAttribute('aria-hidden', hasMessages ? 'true' : 'false');
  }

  statusDiv() {
    return document.getElementById("statusdiv")
  }

  chatForm() {
    return document.getElementById("my-chat-form")
  }

}
